module.exports = __webpack_public_path__ + "static/sumar-mobile@2x-86e3a3ee5e5ea4affb1a450beed4155d.png";